import { useDispatch, useSelector } from "react-redux";

// Actions
import { openLandmarkNearbyForm } from "../../../actions/location-summary/LocationSummaryActions";

// Utils and Constants
import { formatText } from "../../../common-utils/string-utils/StringUtils";
import {
  FormDataTargets,
  LandmarksNearbyConstants,
} from "../../../constants/GeneralConstants";

// Components
import LandmarkNearbyForm from "./LandmarksNearbyForm";

// get Categorized Points
function getCategorizedPoints(points = []) {
  const categorized = points.reduce((acc, item) => {
    const type = item.type || "";
    if (!type) {
      return acc;
    }

    // append key as type for 1st time
    if (!acc[type]) {
      acc[type] = [];
    }

    // push the point
    acc[type].push(item);
    return acc;
  }, {});

  return categorized;
}

// filter Landmarks Which Have Name
function filterLandmarksWhichHaveName(points = []) {
  const filtered = points.filter((point) => point.name);
  return filtered;
}

/**
 * Landmarks Component
 */
export default function Landmarks({
  className = "",
  latitude,
  longitude,
  radius = 1000,
  mediaTitle = "",
  nearByPois = [],
}) {
  const dispatch = useDispatch();

  // landmark nearby modal
  const openLandmarkNearbyModal = useSelector(
    (state) => state.locationSummary.openLandmarkNearbyModal
  );

  // filter points which have name
  const pointsWithName = filterLandmarksWhichHaveName(nearByPois);

  // no points
  if (pointsWithName.length === 0) {
    return null;
  }

  // get points categorization
  const categorizedPointsMap = getCategorizedPoints(pointsWithName);

  return (
    <div className={`landmarks ${className}`}>
      <p>
        <strong>Landmarks nearby</strong>
        <span
          className="text-primary cursor-pointer ml-3"
          title={"Click to see all landmarks and download report"}
          data-toggle="modal"
          data-target={`#${FormDataTargets.landmarkNearbyForm}`}
          onClick={() => dispatch(openLandmarkNearbyForm())}
        >
          (Show All)
        </span>
      </p>

      {LandmarksNearbyConstants.map((landmark, i) => {
        const { key, label } = landmark;
        const landmarksPoints = categorizedPointsMap?.[key] || [];
        const pointsCount = landmarksPoints.length;
        const landMarkName = landmarksPoints[0]?.name;
        return (
          <p key={i}>
            {label} ({pointsCount}): {formatText(landMarkName)}
          </p>
        );
      })}

      {/* MODALS */}
      {/* Landmark Nearby Modal */}
      {openLandmarkNearbyModal && (
        <LandmarkNearbyForm
          latitude={latitude}
          longitude={longitude}
          radius={radius}
          mediaTitle={mediaTitle}
          categorizedPointsMap={categorizedPointsMap}
        />
      )}
    </div>
  );
}
